import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import QuanLyLuongService from "services/salary/QuanLyLuongService";
import Utils from "utils";

export const kiemTraMatKhauBangLuong = createAsyncThunk(
  "quanlyluong/kiemTraMatKhauBangLuong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, matKhau } = data;
      const response = await QuanLyLuongService.kiemTraMatKhauBangLuong(matKhau);
      if (onSuccess)
        onSuccess({
          ...response.data,
        });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const gridSearchBangLuong = createAsyncThunk(
  "quanlyluong/gridSearchBangLuong",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.gridSearchBangLuong(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getBangLuongById = createAsyncThunk(
  "quanlyluong/getBangLuongById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyLuongService.getBangLuongById(id);
      if (onSuccess)
        onSuccess({
          ...response.data,
          thang: Utils.convertMomentToDate(response.data.thang),
        });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertBangLuongAPI = createAsyncThunk(
  "quanlyluong/UpSertBangLuongAPI",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.upSert(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const changeStateBangLuong = createAsyncThunk(
  "quanlyluong/changeStateBangLuong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyLuongService.changeStateBangLuong(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const duyetBangLuong = createAsyncThunk(
  "quanlyluong/duyetBangLuong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyLuongService.duyetBangLuong(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deletedBangLuong = createAsyncThunk(
  "quanlyluong/deletedBangLuong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyLuongService.delete(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const gridSearchBangLuongNhanVien = createAsyncThunk(
  "quanlyluong/gridSearchBangLuongNhanVien",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.gridSearchBangLuongNhanVien(
        data
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const gridSearchBangCongLuong = createAsyncThunk(
  "quanlyluong/gridSearchBangCongLuong",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.gridSearchBangCongLuong(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const gridSearchBangPhuCapGiamTruLuong = createAsyncThunk(
  "quanlyluong/gridSearchBangPhuCapGiamTruLuong",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await QuanLyLuongService.gridSearchBangPhuCapGiamTruLuong(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateBangLuongNhanVien = createAsyncThunk(
  "quanlyluong/updateBangLuongNhanVien",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await QuanLyLuongService.updateBangLuongNhanVien(
        payload
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const bangLuongExport = createAsyncThunk(
  "quanlyluong/bangLuongExport",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.export(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdatedTinhLuongNhanVienByIds = createAsyncThunk(
  "quanlyluong/UpdatedTinhLuongNhanVienByIds",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ids } = data;
      const response = await QuanLyLuongService.updatedTinhLuongNhanVienByIds(
        ids
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdatedBangLuongNhanVienById = createAsyncThunk(
  "quanlyluong/UpdatedBangLuongNhanVienById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.updatedBangLuongNhanVienById(
        payload
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdatedTinhLuongNhanVienById = createAsyncThunk(
  "quanlyluong/UpdatedTinhLuongNhanVienById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyLuongService.updatedTinhLuongNhanVienById(
        id
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SentMailBangLuongNhanVienByIdApi = createAsyncThunk(
  "quanlyluong/SentMailBangLuongNhanVienByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.sentMail(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const bangLuongExportDefault = createAsyncThunk(
  "quanlyluong/bangLuongExportDefault",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.exportDefault(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ImportBangLuongNhanVienApi = createAsyncThunk(
  "quanlyluong/ImportBangLuongNhanVienApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.import(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateImportBangLuongNhanVienSyncApi = createAsyncThunk(
  "quanlyluong/ImportBangLuongNhanVienApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyLuongService.updateImportSync(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDepartmentByBangLuongApi = createAsyncThunk(
  "quanlyluong/GetDepartmentByBangLuongApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.getDepartmentByBangLuong(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateMucDoHoanThanhByDepartment = createAsyncThunk(
  "quanlyluong/UpdateMucDoHoanThanhByDepartment",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response =
        await QuanLyLuongService.updateMucDoHoanThanhByDepartment(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchEmployeeSalaryApi = createAsyncThunk(
  "quanlyluong/SearchEmployeeSalaryApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyLuongService.searchEmployeeSalary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  bangluongList: [],
  bangluongnhanvienList: [],
  bangcongluongList: [],
  bangphucapgiamtruluongList: [],
  departmentList: [],
  employeeList: [],
};

export const quanLyLuongSlice = createSlice({
  name: "quanlyluong",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setHisInfo: (state, action) => {
      state.hisInfoList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gridSearchBangLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(gridSearchBangLuong.fulfilled, (state, action) => {
        state.loading = false;
        state.bangluongList = action.payload;
      })
      .addCase(gridSearchBangLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getBangLuongById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBangLuongById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getBangLuongById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(gridSearchBangLuongNhanVien.pending, (state) => {
        state.loading = true;
      })
      .addCase(gridSearchBangLuongNhanVien.fulfilled, (state, action) => {
        state.loading = false;
        state.bangluongnhanvienList = action.payload.data;
        state.bangLuongCate = action.payload;
      })
      .addCase(gridSearchBangLuongNhanVien.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(gridSearchBangCongLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(gridSearchBangCongLuong.fulfilled, (state, action) => {
        state.loading = false;
        state.bangcongluongList = action.payload;
      })
      .addCase(gridSearchBangCongLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(gridSearchBangPhuCapGiamTruLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(gridSearchBangPhuCapGiamTruLuong.fulfilled, (state, action) => {
        state.loading = false;
        state.bangphucapgiamtruluongList = action.payload;
      })
      .addCase(gridSearchBangPhuCapGiamTruLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertBangLuongAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertBangLuongAPI.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertBangLuongAPI.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deletedBangLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletedBangLuong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletedBangLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedTinhLuongNhanVienByIds.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdatedTinhLuongNhanVienByIds.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedTinhLuongNhanVienByIds.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStateBangLuong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStateBangLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStateBangLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdatedTinhLuongNhanVienById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedTinhLuongNhanVienById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedTinhLuongNhanVienById.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdatedBangLuongNhanVienById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedBangLuongNhanVienById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdatedBangLuongNhanVienById.pending, (state) => {
        state.loading = true;
      })
      .addCase(bangLuongExportDefault.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bangLuongExportDefault.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(bangLuongExportDefault.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        UpdateImportBangLuongNhanVienSyncApi.fulfilled,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(
        UpdateImportBangLuongNhanVienSyncApi.rejected,
        (state, action) => {
          state.loading = false;
        }
      )
      .addCase(UpdateImportBangLuongNhanVienSyncApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SentMailBangLuongNhanVienByIdApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(SentMailBangLuongNhanVienByIdApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SentMailBangLuongNhanVienByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDepartmentByBangLuongApi.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentList = action.payload;
      })
      .addCase(UpdateMucDoHoanThanhByDepartment.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateMucDoHoanThanhByDepartment.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateMucDoHoanThanhByDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(kiemTraMatKhauBangLuong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(kiemTraMatKhauBangLuong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(kiemTraMatKhauBangLuong.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchEmployeeSalaryApi.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeList = action.payload;
      })
      .addCase(SearchEmployeeSalaryApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchEmployeeSalaryApi.pending, (state) => {
        state.loading = true;
      });
  },
});

export const { showLoading } = quanLyLuongSlice.actions;

export default quanLyLuongSlice.reducer;
